import { Injectable, OnInit } from '@angular/core';

import { BehaviorSubject } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
  providedIn: 'root'
})
export class LoaderService implements OnInit {
  public loading = new BehaviorSubject<boolean>(false);
  loading$ = this.loading.asObservable();

  constructor(public spinner: NgxSpinnerService) {

  }

  ngOnInit(): void {
  }

  show() {
    this.loading.next(true);
    document.body.classList.add('loading-active');
    this.spinner.show();
  }

  hide() {
    this.loading.next(false);
    document.body.classList.remove('loading-active');
    this.spinner.hide();
  }
}
